import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { crossIcon } from '../../../Assets/svg'
import CustomButton from '../../CustomButton'
import { useTranslation } from 'react-i18next'
import { cancelTimer, startTimer, tick } from '../../../Store/Slices/TimerSlice'
import { useDispatch, useSelector } from 'react-redux'
import { pauseAllTracks, removeAllTracks, setConfig } from '../../../Store/Slices/PlayerSlice'


let intervalId;

const TimerModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isRunning, timeLeft } = useSelector((state) => state.timer);
    const { isPlaying } = useSelector((state) => state.player);

    useEffect(() => {
        if (isRunning && isPlaying) {
            intervalId = setInterval(() => {
                dispatch(tick());
            }, 1000);
        } else {
            console.log("Clear")
            clearInterval(intervalId);
        }

        return () => clearInterval(intervalId);
    }, [isRunning, isPlaying, dispatch]);

    useEffect(() => {
        if (timeLeft === 0) {
            dispatch(removeAllTracks());
            dispatch(cancelTimer());
            dispatch(setConfig(null));  // ✅ clear currentId
            dispatch(pauseAllTracks()); // ✅ stop if last track
        }
    }, [timeLeft])

    const runTimer = (minutes) => {
        dispatch(startTimer(minutes * 60)); // convert to seconds
        onClose();
    }

    return (
        <Modal
            show={isOpen}
            centered
            onHide={onClose}
            className="soundModal"
            backdrop="static"
        >
            <Modal.Body>
                <div className="text-end">
                    <button
                        className="closeButton notButton ms-auto"
                        onClick={onClose}
                    >
                        <img src={crossIcon} alt="" />
                    </button>
                </div>
                <div className="customModalContent text-center">
                    <h2 className="modalHeading pageTitle mb-4">{t("modals.selectTime")}</h2>
                    <div className="timerOptions">
                        <CustomButton
                            variant="secondaryButton fw-light"
                            text={t("modals.fifteenMinutes")}
                            onClick={() => {
                                runTimer(15);
                            }}
                        />
                        <CustomButton
                            variant="secondaryButton fw-light"
                            text={t("modals.thirtyMinutes")}
                            onClick={() => {
                                runTimer(30);
                            }}
                        />
                        <CustomButton
                            variant="secondaryButton fw-light"
                            text={t("modals.oneHour")}
                            onClick={() => {
                                runTimer(60);
                            }}
                        />
                        <CustomButton
                            variant="secondaryButton fw-light"
                            text={t("modals.twoHours")}
                            onClick={() => {
                                runTimer(120);
                            }}
                        />
                        <CustomButton
                            variant="secondaryButton fw-light"
                            text={t("modals.fourHours")}
                            onClick={() => {
                                runTimer(240);
                            }}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default TimerModal
